import mySuxApi from '../services/dataSources/mySuxApi';

// config
import { config } from '../config';

const URLS = config.URLS;

export const getAmountForOrder = orderIdx => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/order/GetOrderTotal/${orderIdx}/${userId}`;
  return mySuxApi.get(url);
};


export const getAmountAndDetailsForOrder = orderIdx => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/order/GetTotalWithDetails/${orderIdx}/${userId}`;
  return mySuxApi.get(url);
};



// WEBPACK FOOTER //
// ./src/actions/payment.js